import React from 'react';
import { TableMyResultView } from './TableMyResult.view';
import { useQuery } from '@apollo/client';
import { QUERY_SOFT_SKILLS } from '../../../../graphql/query/note/softSkills.query';
import { useRefetchData } from '../../../../helpers/refetch/refetchData';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import FrontError from '../../../../helpers/errors/front.error';
import { ToRequiredType } from '../../../../types/typeDef';
import { calculTauxEngagement } from 'domain/commission/commission';
import {
  QuerySoftSkillsQuery,
  UnpayedCa
} from '../../../../graphql/generated/graphql';
import { getUserPerfsFromQuery } from '../../../../helpers/transformApiResponse/user';

export const TableMyResult = () => {
  const { data, loading, error, refetch } = useQuery<QuerySoftSkillsQuery>(
    QUERY_SOFT_SKILLS
  );

  useRefetchData(refetch);
  if (loading) return <LoadingContainer variant="TableMyResult" />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new FrontError(
            'TableMyResult :récupération des performances commerciales',
            error
          )
        }
        text={"Veuillez recharger l'affichage des performances commerciales"}
        setFeedback
      />
    );

  const user = getUserPerfsFromQuery(data?.getUserSoftSkills);
  const engagementRate = calculTauxEngagement(
    user.classe.users.filter(u => u.role.id !== process.env.REACT_APP_PROF_ID)
  );

  return (
    <TableMyResultView
      userPerfs={user}
      caToPay={data?.getUnpayedCo as ToRequiredType<UnpayedCa>}
      engagementRate={engagementRate}
    />
  );
};
